export const getPath = (path?: string): string => {
  if (!path) {
    return '/';
  }
  if (path.startsWith('/')) {
    return path;
  }
  return `/${path}`;
};
